// safetyFormLists/safetyFormReports/safetyFormListsSafetyFormReportsState.js

import { filtersInitialState } from "../../shared/filters/filtersState";

export const safetyFormReportsInitialState = {
  items: [],
  tableType: "safety_form_reports",
  activeFormType: "near_miss",
  totalCount: 0,
  currentPage: 1,
  pageSize: 10,
  loading: false,
  error: null,
  needsUpdate: false,
  selectedForm: null,
  selectedNearMissIds: [],
  selectedSafetyAuditIds: [],
  hasMore: false,
  isFiltered: false,
  filters: filtersInitialState(),
};
